import GeneralHelper from "../../../../common/helpers/GeneralHelper";
import CustomerService from "../../../../common/services/customer/CustomerService";
import KitService from "../../../../common/services/kit/KitService";
import { SHOW_TOAST_MESSAGE } from "../../../../common/store/actions";
import {
    DUPLICATE_CUSTOMER_LISTING,
    DELETE_CUSTOMER_LISTING,
    GET_CUSTOMER_LISTINGS,
    GET_CUSTOMER_LIVE_LISTINGS,
    GET_CUSTOMER_SOLD_LISTINGS,
    UPDATE_STATUS,
    LISTING_LAYOUT_CURRENT_COMP,
} from "./actions";
import Listing from "../../components/listing/Listing";
import  Request from "../../components/rfp/Requests";
import AuthHelper from "../../../../common/helpers/AuthHelper";
export default {
    /**
     * TODO change the state variable names and getters  to camelCase
     */
    state: {
        listings: [],
        soldListings:[],
        listingLayoutCurrentComp:  
        {value: Listing, id: 1} ,
    },
    getters: {
        customerListings: (state) => {
            return state.listings;
        },
        customerSoldListings: (state) =>{
            return state.soldListings;
        },
        listingLayoutCurrentComp: (state) => {
            return state.listingLayoutCurrentComp;
        },
    },
    mutations: {
        [LISTING_LAYOUT_CURRENT_COMP]: (state, data) => {
            
            state.listingLayoutCurrentComp = data;
        },
        [GET_CUSTOMER_LISTINGS]: (state, data) => {
            state.listings = data;
        },

        [GET_CUSTOMER_SOLD_LISTINGS]: (state, data) => {
            state.soldListings = data;
        },
        [DELETE_CUSTOMER_LISTING]: (state, id) => {
            state.listings.forEach((item, index) => {
                if (item.id == id) {
                    state.listings.splice(index, 1);
                    return;
                }
            });
        },

    },
    actions: {
        [UPDATE_STATUS]: async(context, data) => {
            var kitService = new KitService();
            var result = await kitService.editStatus({
                id: data.id,
                customer_id: context.getters.customer.id,
                availibility_id: data.status,
            });
            return result;
        },
        [GET_CUSTOMER_LISTINGS]: async(context) => {
            var customerService = new CustomerService();
            var results = await customerService.getCustomerListings(
                context.getters.customer.id
            );

            context.commit(GET_CUSTOMER_LISTINGS, results.data.data.data);
            return results.data.data.data;
        },
        [GET_CUSTOMER_LIVE_LISTINGS]: async(context) => {
            var customerService = new CustomerService();
            var results = await customerService.getCustomerLiveListings(
                context.getters.customer.id
            );

            context.commit(GET_CUSTOMER_LISTINGS, results.data.data.data);
            return results.data.data.data;
        },

        [GET_CUSTOMER_SOLD_LISTINGS]: async(context) => {
            var customerService = new CustomerService();
            var results = await customerService.getCustomerSoldListings(
                context.getters.customer.id
            );
            context.commit(GET_CUSTOMER_SOLD_LISTINGS, results.data.data.data);
  
            return results.data.data.data;
        },

        [DELETE_CUSTOMER_LISTING]: async(context, ids) => {
            if (!AuthHelper.checkAuthForAction(context)) return await new Promise();
            var kitService = new KitService();
            var results = await kitService.deleteKits(ids)
                .then((results) => {
                    if(results.data.data.soldKits){
                        context.dispatch(
                            SHOW_TOAST_MESSAGE,
                            GeneralHelper.buildMessage(2, "You can't delete your sold items !")
                        );
                    }else {
                        context.dispatch(
                            SHOW_TOAST_MESSAGE,
                            GeneralHelper.buildMessage(1, "Successfully Deleted !")
                        );
                    }
                   
                    ids.forEach((id) => {
                        context.commit(DELETE_CUSTOMER_LISTING, id);
                    });
                    
                })
                .catch(() => {
                    context.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(3, "Something Went Wrong!")
                    );
                });
        },
        [DUPLICATE_CUSTOMER_LISTING]: //async
            (context, id) => {
            if (!AuthHelper.checkAuthForAction(context)) return;
            var kitService = new KitService();
            kitService
                .duplicate(id)
                .then((data) => {
                    context.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(1, "Successfully Duplicated !")
                    ).then(() => {
                        context.dispatch(GET_CUSTOMER_LISTINGS);
                    });;
                })
                .catch((e) => {
                    context.dispatch(
                        SHOW_TOAST_MESSAGE,
                        GeneralHelper.buildMessage(3, "Something Went Wrong!")
                    );
                });
        },
    },
};